import React, { useEffect, useState } from "react";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../constant/colors";
import { LeadStageCountListType } from "../../redux/clientDirectory/clientDirectoryType";

type AppProps = {
  leadStageCount: LeadStageCountListType[] | [];
};
const LeadStageCount = ({ leadStageCount }: AppProps) => {
  const [rowBox, setStageBox] = useState(false);
  const [archivedBox, setArchivedBox] = useState(true);
  const [wonBox, setWonBox] = useState(true);
  const [progressBox, setProgressBox] = useState(true);
  const [jobBox, setJobBox] = useState(true);

  useEffect(() => {
    // if(LeadStageCount?.length)
    const leadStage: any =
      leadStageCount?.length &&
      leadStageCount?.map((el: LeadStageCountListType) => el?.stage);
    if (leadStage?.length) {
      const stageBoxPresent: boolean = leadStage?.includes("1: Raw") || leadStage?.includes("1a: New Lead")|| false;
      if (stageBoxPresent) {
        setStageBox(true);
      } else {
        setStageBox(false);
      }
      const progressBoxPresent: boolean =
        leadStage?.includes("2a: In-Progress") ||
        leadStage?.includes("2b: Interested in Combo") ||
        leadStage?.includes("2b: Interested in Services") ||
        leadStage?.includes("2b: Interested in Software") ||
        leadStage?.includes("2bii: Keep for emailer reach") ||
        leadStage?.includes("2biii: Pending Demo") ||
        leadStage?.includes("2biv: Pending Post Demo Follow-up") ||
        leadStage?.includes("2bv: Proposal Sent") ||
        leadStage?.includes("2bvi: Meeting Done") ||
        false;
      if (progressBoxPresent) {
        setProgressBox(true);
      } else {
        setProgressBox(false);
      }

      const archivedBoxPresent: boolean =
        leadStage?.includes("3a: Archived") ||
        leadStage?.includes("3b: Bad") ||
        false;
      if (archivedBoxPresent) {
        setArchivedBox(true);
      } else {
        setArchivedBox(false);
      }

      const wonBoxPresent: boolean =
        leadStage?.includes("2c: Won") ||
        leadStage?.includes("2c: Won - EL Signed") ||
        leadStage?.includes("2d: Won - Invoice issued") ||
        false;
      if (wonBoxPresent) {
        setWonBox(true);
      } else {
        setWonBox(false);
      }

      const jobBoxPresent: boolean =
        leadStage?.includes("4a: Require Accountant (Full Time)") ||
        leadStage?.includes("4b: Require Accountant (Part Time)") ||
        leadStage?.includes("5: Job requirement") ||
        false;
      if (jobBoxPresent) {
        setJobBox(true);
      } else {
        setJobBox(false);
      }
    }
  }, [leadStageCount]);

  const backColor = (name: string) => {
    const lowerCaseName = name.toLowerCase();

    let backgroundColor;
    let fontColor;

    if (lowerCaseName.startsWith("1") || lowerCaseName.startsWith("1a")) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("2a") ||
      lowerCaseName.startsWith("2b") ||
      lowerCaseName.startsWith("2bii") ||
      lowerCaseName.startsWith("2biii") ||
      lowerCaseName.startsWith("2biv") ||
      lowerCaseName.startsWith("2bv") ||
      lowerCaseName.startsWith("2bvi")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("2c") ||
      lowerCaseName.startsWith("2d")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("3a") ||
      lowerCaseName.startsWith("3b")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("4a") ||
      lowerCaseName.startsWith("4b") ||
      lowerCaseName.startsWith("5")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };
  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      marginTop: "10px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };

  const checkStage = (stageArray: any, value: string) => {
    return stageArray.some((element: any) => element?.stage === value);
  };

  return (
    <>
      {leadStageCount?.length ? (
        <div className="row d-flex mb-3 ml-3">
          {(rowBox || archivedBox || wonBox) && (
            <div className="col-md-3">
              {rowBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    padding: "0px 10px 10px 10px",
                  }}
                >
                  {leadStageCount?.length
                    ? leadStageCount?.map((el: any) => {

                        const lowerCaseName = el?.stage ? el?.stage.toLowerCase() : "";

                        if (lowerCaseName.startsWith("1")) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              style={{ paddingBottom: "10px" }}
                            >
                              <span
                                style={
                                  el?.stage ? styleColor(el?.stage) : blank()
                                }
                              >
                                {el?.stage}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}
              {archivedBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    marginTop: "10px",
                    padding: "0px 10px 10px 10px",
                    overflow: "auto",
                  }}
                >
                  {leadStageCount?.length
                    ? leadStageCount?.map((el: any) => {
                        const lowerCaseName = el?.stage ? el?.stage.toLowerCase() : "";

                        if (
                          lowerCaseName.startsWith("3a") ||
                          lowerCaseName.startsWith("3b")
                        ) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              style={{ marginBottom: "10px" }}
                            >
                              <span
                                style={
                                  el?.stage ? styleColor(el?.stage) : blank()
                                }
                              >
                                {el?.stage}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}
              {wonBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    marginTop: "10px",
                    padding: "0px 10px 10px 10px",
                    overflow: "auto",
                  }}
                >
                  {leadStageCount?.length
                    ? leadStageCount?.map((el: any) => {
                      const lowerCaseName = el?.stage ? el?.stage.toLowerCase() : "";

                        if (
                          lowerCaseName.startsWith("2c") ||
                          lowerCaseName.startsWith("2d")
                        ) {
                          return (
                            <div className="d-flex justify-content-between">
                              <span
                                style={
                                  el?.stage ? styleColor(el?.stage) : blank()
                                }
                              >
                                {el?.stage}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}
            </div>
          )}
          {progressBox && (
            <div
              style={{
                width: "30%",
                border: "1px solid rgba(191, 203, 225, 0.6)",
                borderRadius: "4px",
                overflow: "auto",
                padding: "0px 10px 10px 10px",
              }}
            >
              {leadStageCount?.length
                ? leadStageCount?.map((el: any) => {
                  const lowerCaseName = el?.stage ? el?.stage.toLowerCase() : "";

                    if (
                      lowerCaseName.startsWith("2a") ||
                      lowerCaseName.startsWith("2b") ||
                      lowerCaseName.startsWith("2bii") ||
                      lowerCaseName.startsWith("2biii") ||
                      lowerCaseName.startsWith("2biv") ||
                      lowerCaseName.startsWith("2bv") ||
                      lowerCaseName.startsWith("2bvi")
                    ) {
                      return (
                        <div className="d-flex justify-content-between">
                          <span
                            style={el?.stage ? styleColor(el?.stage) : blank()}
                          >
                            {el?.stage}
                          </span>
                          <span
                            style={{ marginTop: "10px", fontWeight: "600" }}
                          >
                            {el?.count < 10 ? `0${el?.count}` : el?.count}
                          </span>
                        </div>
                      );
                    }
                  })
                : ""}
            </div>
          )}
          {jobBox && (
            <div
              className="ml-3"
              style={{
                width: "30%",
                border: "1px solid rgba(191, 203, 225, 0.6)",
                borderRadius: "4px",
                padding: "0px 10px 0px 10px",
                overflow: "auto",
              }}
            >
              {leadStageCount?.length
                ? leadStageCount?.map((el: any) => {
                  const lowerCaseName = el?.stage ? el?.stage.toLowerCase() : "";

                    if (
                      lowerCaseName.startsWith("4a") ||
                      lowerCaseName.startsWith("4b") ||
                      lowerCaseName.startsWith("5")
                    ) {
                      return (
                        <div
                          className="d-flex justify-content-between"
                          style={{ paddingBottom: "10px" }}
                        >
                          <span
                            style={el?.stage ? styleColor(el?.stage) : blank()}
                          >
                            {el?.stage}
                          </span>
                          <span
                            style={{ marginTop: "10px", fontWeight: "600" }}
                          >
                            {el?.count < 10 ? `0${el?.count}` : el?.count}
                          </span>
                        </div>
                      );
                    }
                  })
                : ""}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default LeadStageCount;
